import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field } from 'redux-form';
import { Theme, colors } from '../../../legacy/hui/src/styled/theme';
import { ErrorText } from '../Field';
import { Theme as ThemeBunnings } from '../Bunnings/Theme';
import { TitleTips } from './style/TitleTips';
import Socium from '../../constants/Socium';
import { requiredYesForExistingToiletForBunnings } from '../../utils/validation';

const QuestionLabel = styled.label`
  display: block;
  margin-top: 25px;
  font-weight: 600;
  margin-bottom: 15px;
`;

const AnswerLabel = styled.label`
  cursor: pointer;
  padding: 10px 15px;
  border: 1px solid ${colors.GREY};
  border-radius: 100px;
  background-color: ${Theme.snow};
  color: ${colors.MEDIUM_DARK_GREY};
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
`;

const RadioOption = styled.div`
  display: inline-block;
  margin: 0 5px 5px 0;

  input[type='radio']:checked + label {
    background: ${ThemeBunnings.primary};
    color: ${Theme.snow};
    border-color: ${ThemeBunnings.primary};
  }
`;

export const Radio = styled(Field)`
  display: none;
`;

const ErrorMessage = ({ meta }) => {
  return meta.error && meta.touched ? <ErrorText className="error">{meta.error}</ErrorText> : null;
};

ErrorMessage.propTypes = {
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool
  })
};

export default function RadioGroup({ options, name, label, tip, ...rest }) {
  const { id } = rest;
  const getRadioValidationRule = questionId => {
    switch (questionId) {
      case Socium.QUESTION_EXISTING_TOILET_IN_REPLACE_BUNNINGS:
        return [requiredYesForExistingToiletForBunnings];
      default:
        return [];
    }
  };
  return (
    <div>
      <QuestionLabel>
        <span>{label}</span>
        {tip && <TitleTips>{tip}</TitleTips>}
      </QuestionLabel>
      {options.map(({ value, label }) => {
        const key = `${name}_${value}`;
        return (
          <RadioOption key={key}>
            <Radio
              type="radio"
              name={name}
              id={key}
              value={`${value}`}
              component={({ input, ...rest }) => {
                return <input name={name} {...input} {...rest} />;
              }}
            />

            <AnswerLabel key={key} htmlFor={key}>
              {label}
            </AnswerLabel>
          </RadioOption>
        );
      })}
      <Field name={name} component={ErrorMessage} validate={getRadioValidationRule(id)} />
    </div>
  );
}

RadioGroup.propTypes = {
  options: PropTypes.array,
  name: PropTypes.string,
  label: PropTypes.string,
  tip: PropTypes.string
};
